import React, { createContext, useContext, type PropsWithChildren } from 'react';

import type { TargetType } from '@atlassiansox/cross-flow-base-types';

type OnboardingModalContextType = {
	open: boolean;
	targetProduct: TargetType | undefined;
};

const OnboardingModalContext = createContext<OnboardingModalContextType>({
	open: false,
	targetProduct: undefined,
});

type OnboardingModalType = {
	targetProduct: TargetType;
	open: boolean;
};

export const OnboardingModalContextProvider = ({
	children,
	targetProduct,
	open,
}: PropsWithChildren<OnboardingModalType>) => {
	return (
		<OnboardingModalContext.Provider value={{ open, targetProduct }}>
			{children}
		</OnboardingModalContext.Provider>
	);
};

export const useOnboardingModalContext = () => useContext(OnboardingModalContext);
